import * as React from 'react';
import classes from './Switch.module.css';
import classNames from 'classnames';

type SwitchProps = {
  checked?: boolean;
  onChange: (checked: boolean) => void;
}

const Switch = ({
  checked,
  onChange,
}: SwitchProps) => {
  return (
    <label
      className={classNames(
        classes['switch'],
        checked && classes['checked'],
      )}
    >
      <input
        type="checkbox"
        id="switch"
        checked={checked}
        onChange={({ target }) => onChange(target.checked)}
      />
      <span />
    </label>
  );
};

export default Switch;
